import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MaxLengthModule } from '@avenir-client-web/max-length';
import { InputTextModule } from 'primeng/inputtext';
import { InputComponent } from './input.component';

@NgModule({
  imports: [
    CommonModule,
    InputTextModule,
    MaxLengthModule,
    FormsModule,
    InputComponent,
  ],
  exports: [InputComponent],
})
export class InputModule {}
